import React from "react";
import { Nav } from "@/components/site/Nav";
import { PolicyReview } from "@/components/site/PolicyReview";
import { Footer } from "@/components/site/Footer";

export default function PolicyReviewPage() {
  return (
    <div className="min-h-screen bg-paper text-nearblack font-sans antialiased">
      <Nav heroVisible={false} />

      {/* Push content below the fixed nav */}
      <div className="pt-20 md:pt-24" />

      <PolicyReview />

      <Footer />
    </div>
  );
}
